import React from 'react';
import { motion } from 'framer-motion';
import { Calendar } from 'lucide-react';
const fadeIn = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
export function ScheduleHero() {
  return <section className="pt-16 pb-12 px-4 bg-gradient-to-b from-blue-50 to-white" data-id="element-760">
      <div className="max-w-6xl mx-auto text-center" data-id="element-761">
        <motion.div initial="hidden" animate="visible" variants={fadeIn} className="space-y-6" data-id="element-762">
          <div className="flex items-center justify-center gap-3 mb-4" data-id="element-763">
            <Calendar className="w-8 h-8 text-[#0f1f3d]" data-id="element-764" />
            <h1 className="text-4xl sm:text-5xl md:text-6xl font-black text-[#0f1f3d]" data-id="element-765">
              Class Schedule
            </h1>
          </div>
          <div className="w-24 h-1 bg-[#a3d977] mx-auto rounded-full mb-6" data-id="element-766"></div>
          <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed" data-id="element-767">
            Find the perfect class time for your family. All classes are
            designed to build confidence, discipline, and skill.
          </p>
        </motion.div>
      </div>
    </section>;
}